import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { StaticPathUtil } from '@app/core/util/static-path.util';
import { Kontakt } from '@pezi/entities';
import { NgIf } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ContactDetailComponent } from '../../contact-detail/contact-detail.component';
import { PeziButtonComponent } from '../../pezi-button/pezi-button.component';

@Component({
  selector:   'app-kontakt-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls:  ['./contact-dialog.component.scss'],
  standalone: true,
  imports:    [
    NgIf,
    CdkScrollable,
    MatDialogContent,
    ContactDetailComponent,
    MatDialogActions,
    PeziButtonComponent,
    MatDialogClose
  ]
})
export class ContactDialogComponent  {

  constructor(@Inject(MAT_DIALOG_DATA) public data: KontaktDialogData, public staticPath: StaticPathUtil,
              private dialogRef: MatDialogRef<ContactDialogComponent>, private router: Router) {
  }



}

export interface KontaktDialogData {
  kontakt: Kontakt;
  showRelated?: boolean
}
